import { generatePesticideReportData } from "../../../actions/chemistry";
import { moveToHistory } from "./Components/History/ChemHistoryHelper";
import { checkReadyReports } from "../../../actions/sendReports";

export const checkLessThan = (value) => {
  if (String(value).includes("<") || value === "default") {
    return 0;
  }
  return value;
};

const MRL_RESULT_PATTERN = /^<?\d+(\.\d+)?$/;
const MRL_RESULT_ERROR_MESSAGE = "Result must be a whole number, decimal, or < followed by a number (e.g. 10, 10.0, <10, <10.0)";

export const mrlResultRule = (message = MRL_RESULT_ERROR_MESSAGE) => ({
  validator: (_, value) => {
    const str = String(value ?? "");
    const trimmed = str.trim();
    if (!trimmed) {
      if (str.length > 0) return Promise.reject(new Error(message));
      return Promise.resolve();
    }
    if (!MRL_RESULT_PATTERN.test(trimmed)) return Promise.reject(new Error(message));
    return Promise.resolve();
  },
});

/**
 * Parse the data from a pestcide excel file, then make an api call to update the data
 * @param {*} rows
 * @param {*} file
 * @param {*} product
 * @returns
 */
export const parsePesticide = async (rows, file, product) => {
  function parsePesticideXcel(pRows) {
    const list = [];
    const testP = [];
    const testR = [];
    const gbList = [];

    for (let i = 0; i < pRows.length; i++) {
      const eletest = pRows[i];
      const regEx = new RegExp(/GB/);
      const gb = {
        gb: "", product: "", parameter: [], result: [],
      };
      if (eletest[0] !== null && eletest[0] !== "default" && eletest[0].match(regEx)) {
        gb.gb = eletest[0];
        gb.product = pRows[i + 1][0];
        i += 2;
        let j = i;
        while (j < pRows.length) {
          const ele = pRows[j];
          if (ele[0] === null || ele[0] === "default") {
            break;
          } else {
            gb.parameter.push(ele[0]);
            gb.result.push(ele[2]);
            j++;
          }
        }
        gbList.push(gb);
      }
    }

    for (let index = 10; index < pRows.length; index++) {
      const element = pRows[index];
      if (element[0] !== null && element[0] !== "default") {
        testP.push(element[0]);
        testR.push(element[2]);
      } else {
        break;
      }
    }

    const allSamples = [];

    for (let i = 0; i < gbList.length; i++) {
      const eachSample = [];
      for (let j = 0; j < gbList[i].parameter.length; j++) {
        eachSample.push({
          Parameter: gbList[i].parameter[j],
          Result: gbList[i].result[j],
          BRA: "N/A",
          CAN: "N/A",
          CHL: "N/A",
          CHN: "N/A",
          EU: "N/A",
          HKG: "N/A",
          IND: "N/A",
          JPN: "N/A",
          KOR: "N/A",
          NZL: "N/A",
          PER: "N/A",
          TWN: "N/A",
          US: "N/A",
          ARE: "N/A",
        });
      }
      allSamples.push(eachSample);
    }

    for (let i = 0; i < testP.length; i++) {
      list.push({
        Parameter: testP[i],
        Result: testR[i],
        BRA: "N/A",
        CAN: "N/A",
        CHL: "N/A",
        CHN: "N/A",
        EU: "N/A",
        HKG: "N/A",
        IND: "N/A",
        JPN: "N/A",
        KOR: "N/A",
        NZL: "N/A",
        PER: "N/A",
        TWN: "N/A",
        US: "N/A",
        ARE: "N/A",
      });
    }

    const getInfoAll = [];
    const getAllID = [];
    const getAllProductName = [];
    for (let i = 0; i < allSamples.length; i++) {
      getAllID.push(gbList[i].gb);
      getAllProductName.push(gbList[i].product);
      const getInformation = {
        genista_id: gbList[i].gb,
        product: gbList[i].product,
        result: [],
      };
      const eachSample = allSamples[i];
      for (let j = 0; j < eachSample.length; j++) {
        const obj = {};
        obj.name = eachSample[j].Parameter;
        obj.value = eachSample[j].Result;
        getInformation.result.push(obj);
      }
      getInfoAll.push(getInformation);
    }

    return getInfoAll;
  }

  try {
    const regEx = new RegExp(/GB/);
    let element;
    for (let i = 0; i < rows.length - 1; i++) {
      if (rows[i][0] != null && rows[i][0] !== "defualt" && rows[i][0].match(regEx)) {
        element = rows[i];
        break;
      }
    }
    if (!element) {
      return { success: false, message: "Please upload a valid excel" };
    }
    if (element[0].match(regEx)) {
      const payload = parsePesticideXcel(rows);
      const response = await generatePesticideReportData(payload);
      if (response.success) {
        product.xls = [];
        moveToHistory(file, response, "Pesticide", "");
        checkReadyReports();
        return { ...response, product };
      }
      return { success: false, message: "Something went wrong" };
    }
    return { success: false, message: "Please upload a valid excel" };
  } catch (e) {
    return { success: false, message: "Something went wrong" };
  }
};
